import { Injectable } from '@angular/core';
import { SortDirection } from '@angular/material/sort';
import { ARApiUrlBuilderService, ARPagedResponseDataModel, ARRequestOptions } from '@relayter/core';
import { Observable } from 'rxjs';
import { TeamMemberModel } from 'src/app/models/response/team-member.model';
import { environment } from '../../../environments/environment';
import { QueryParams } from '../../classes/query-params';
import { ApiConstants } from '../api.constant';
import { BaseApiRequestService } from './base-api-request.service';

@Injectable({ providedIn: 'root' })
export class TeamMemberService extends BaseApiRequestService {
    public getTeamMembers(
        teamId: string,
        excludeIds,
        limit: number,
        offset = 0,
        sortProperty?: string,
        sortOrder?: SortDirection,
        search = ''
    ): Observable<ARPagedResponseDataModel<TeamMemberModel>> {
        const queryParams = new QueryParams().setLimitAndOffsetParams(limit, offset).setSortAndSortDirectionParams(sortProperty, sortOrder);
        if (search) queryParams.addParam('search', search);
        queryParams.addParam('excludeIds', excludeIds);

        const url = ARApiUrlBuilderService.urlFromComponents(
            [
                environment.API_SERVER,
                ApiConstants.API_BASE_PATH,
                ApiConstants.API_PATH_ADMIN,
                ApiConstants.API_PATH_TEAMS,
                teamId,
                ApiConstants.API_GROUP_TEAM_MEMBERS
            ],
            queryParams.getParams()
        );

        const options: ARRequestOptions = new ARRequestOptions();
        options.method = ApiConstants.REQUEST_METHODS.GET;
        options.url = url;
        return new Observable((obs) => {
            this.handlePagedResponse(options, obs, TeamMemberModel);
        });
    }
}
